import { pick } from 'lodash';
import { compose } from 'lodash/fp';
import { Component, ReactNode } from 'react';
import { ClickAwayProps, ScrollAwayProps, withClickAway, withScrollAway } from '@optimus-web/helpers';
import OpenableOverlay from './OpenableOverlay';

interface WithToggleableOverlayProps extends ClickAwayProps, ScrollAwayProps {
    anchorElement?: ReactNode | (() => ReactNode);
    sizeToAnchor?: boolean;
    innerRef?: () => void;
    onOpen?: () => void;
    onClose?: () => void;
}

const withToggleableOverlay =
    ({ handleProps = [], componentProps = [], clickAway = true, scrollAway = true } = {}) =>
    ({ HandleComponent, ContentComponent, OpenableOverlayComponent = OpenableOverlay }: $TSFixMe) => {
        class OverlayCombinator extends Component<WithToggleableOverlayProps> {
            containerElement: $TSFixMe;
            overlayElement: $TSFixMe;

            state = {
                opened: false,
            };

            handleClick = () => {
                if (!this.state.opened) {
                    this.setState({ opened: true });
                    const options = {
                        handler: this.handleClose,
                        roots: [() => this.containerElement, () => this.overlayElement],
                    };

                    if (scrollAway) {
                        (this.props as $TSFixMe).registerScrollAway(options);
                    }

                    if (clickAway) {
                        (this.props as $TSFixMe).registerClickAway(options);
                    }

                    if ((this.props as $TSFixMe).onOpen) {
                        (this.props as $TSFixMe).onOpen();
                    }
                } else {
                    this.handleClose();
                }
            };

            handleClose = () => {
                if (this.state.opened) {
                    this.setState({ opened: false });

                    if (scrollAway) {
                        (this.props as $TSFixMe).deregisterScrollAway();
                    }

                    if (clickAway) {
                        (this.props as $TSFixMe).deregisterClickAway();
                    }

                    if ((this.props as $TSFixMe).onClose) {
                        (this.props as $TSFixMe).onClose();
                    }
                }
            };

            containerRef = (c: $TSFixMe) => {
                this.containerElement = c;
                if ((this.props as $TSFixMe).innerRef) {
                    (this.props as $TSFixMe).innerRef(c);
                }
            };

            overlayRef = (c: $TSFixMe) => (this.overlayElement = c);

            anchorElementGetter = () => this.containerElement;

            render() {
                const {
                    sizeToAnchor,
                    anchorElement,
                    deregisterScrollAway,
                    deregisterClickAway,
                    registerScrollAway,
                    registerClickAway,
                    // @ts-expect-error $TSFixMeError: Property 'componentRef' does not exist on type 'Readonly<{}> & Readonly<{ children?: ReactNode; }>'.
                    componentRef,
                    innerRef,
                    ...other
                } = this.props;

                const containerProps = {
                    ref: this.containerRef,
                };

                const handleComponentProps = {
                    ...pick(other, handleProps),
                    onClick: this.handleClick,
                    opened: this.state.opened,
                };

                const contentComponentProps = {
                    ...pick(other, componentProps),
                    close: this.handleClose,
                };

                const overlayProps = {
                    anchorElement: anchorElement || this.anchorElementGetter,
                    opened: this.state.opened,
                    sizeToAnchor,
                    innerRef: this.overlayRef,
                };

                return (
                    <div {...containerProps}>
                        <HandleComponent {...handleComponentProps} />
                        <OpenableOverlayComponent {...overlayProps}>
                            <ContentComponent {...contentComponentProps} />
                        </OpenableOverlayComponent>
                    </div>
                );
            }
        }
        // @ts-expect-error $TSFixMeError: Argument of type '<P extends ScrollAwayProps, T extends ReactComponent<P, {}, any>>(Component: React.ComponentType<P>) =...
        return compose(withScrollAway, withClickAway)(OverlayCombinator);
    };

export default withToggleableOverlay;
